import React from "react";
import { cn } from "../lib/utils";
import { InfoTooltip } from "./InfoTooltip";

export function KpiCard({ label, value, delta, hint, icon: Icon, info, testId, className }) {
  return (
    <div
      data-testid={testId || "kpi-card"}
      className={cn(
        "bg-card border border-border rounded-lg p-5 flex flex-col gap-3 transition-colors hover:border-foreground/30",
        className
      )}
    >
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-1.5">
          <span className="text-xs font-medium uppercase tracking-wider text-muted-foreground">{label}</span>
          {info && <InfoTooltip text={info} />}
        </div>
        {Icon && <Icon className="w-4 h-4 text-muted-foreground" strokeWidth={1.5} />}
      </div>
      <div className="flex items-baseline gap-2">
        <span className="text-2xl font-semibold tracking-tight" data-testid={`kpi-value-${(label || "").toLowerCase().replace(/\s+/g, "-")}`}>
          {value ?? "—"}
        </span>
        {delta && <span className="text-xs text-muted-foreground">{delta}</span>}
      </div>
      {hint && <p className="text-xs text-muted-foreground">{hint}</p>}
    </div>
  );
}
